import type { RouteObject } from 'react-router-dom'
import Home from '@/pages/Home'
import { Navigate, useRoutes } from 'react-router-dom'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/calculators', element: <Navigate to="/calculators/molarity" replace /> },
  { path: '/calculators/molarity', element: <Home /> },
  { path: '/calculators/doubling', element: <Home /> },
  { path: '/calculators/qpcr', element: <Home /> },
  { path: '/calculators/:calcId', element: <Home /> },
  { path: '/directory', element: <Home /> },
  { path: '/legal', element: <Home /> },
]

function App() {
  return useRoutes(routes)
}

export default App
